import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class ZenerDiodeAlogorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVzTyp = 12;
		this.normPdMax = 2;

		this.rankVzTyp = 0;
		this.rankPdMax = 0;

		this.weightVzTyp = 0.3;
		this.weightPdMax = 0.2;

		this.rVzTyp = 0;
		this.rPdMax = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_VzTyp,rVzTyp,rankVzTyp,part_PdMax,rPdMax,rankPdMax,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Zener voltage  VZ Typ (V)---------------------------------------------

		[this.rankVzTyp, this.rVzTyp] = this.calculateRankSingleSliderGTE(
			CIDS.TYPICAL_ZENER_VOLTAGE,
			product,
			this.normVzTyp
		);

		// ---------------------------------------------Power dissipation  PD Max (W)---------------------------------------------

		[this.rankPdMax, this.rPdMax] = this.calculateRankSingleSliderGTE(CIDS.MAX_POWER, product, this.normPdMax);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightVzTyp * this.rankVzTyp + this.weightPdMax * this.rankPdMax;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVzTyp - this.weightPdMax) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
